import { IDataModal } from 'screens/estimate';
import ModalRedirectToPageWizard from '../modalRedirectToPageWizard';
import { API_WIZARD_BUY, TILDA_PATHS } from 'lib/constants';

export type TModeBuyModal = 'buy' | 'tarde-in';

interface IModalTradeInProps {
  isOpen: boolean;
  data: IDataModal | null;
  mode: TModeBuyModal;
  onDismiss: (value: boolean) => void;
}

const TEXT_BUY =
  'Перейдите к оформлению заявки и мы поможем подобрать вам жилье на выгодных условиях.';

const TEXT_TRADEIN =
  'Trade-in услуга по обмену вашей квартиры на новую. Перейдите к оформлению заявки и мы поможем подобрать вам новое жилье.';

const TITLE_BUY = 'Помощь в покупке';
const TITLE_TRADEIN = 'Trade-in';

const ModalRedirectToPageWizardBuy = ({ isOpen, data, mode, onDismiss }: IModalTradeInProps) => {
  const handleRedirect = () => {
    window.open(TILDA_PATHS.reitInvest.tradeIn, '_blank');
  };

  return (
    <ModalRedirectToPageWizard
      title={mode === 'buy' ? TITLE_BUY : TITLE_TRADEIN}
      text={mode === 'buy' ? TEXT_BUY : TEXT_TRADEIN}
      onRedirect={handleRedirect}
      onDismiss={onDismiss}
      isOpen={isOpen}
    />
  );
};
export default ModalRedirectToPageWizardBuy;
